import { render } from "./TopStatItemComponent.vue?vue&type=template&id=5d7149d4&scoped=true&ts=true"
import script from "./TopStatItemComponent.vue?vue&type=script&lang=ts"
export * from "./TopStatItemComponent.vue?vue&type=script&lang=ts"

import "./TopStatItemComponent.vue?vue&type=style&index=0&id=5d7149d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7149d4"]])

export default __exports__